module.exports = __webpack_public_path__ + "static/media/downloadCircle.d75d1151.svg";